<template>
  <div>
    <v-row class="b-table-module__header">
      <v-col>
        <slot name="header" />
      </v-col>
    </v-row>
    <SearchFilterBar class="w-table-module__search-bar" v-model="searchFilter">
      <slot name="searchFilter" />
    </SearchFilterBar>
    <LazyLoadingTable
        :class="cssClass"
        :headers="internalHeaders"
        :filter="filterValues"
        @click:row="openForm"
        :path="path"
        :loading="loading"
        :loading-text="loadingText"
        @update:lazy-items="loading = false"
    />
  </div>
</template>

<script>
import LazyLoadingTable from './tables/LazyLoadingTable';
import SearchFilterBar from '../base_components/SearchFilterBar';
//import { mapState } from 'vuex';

export default {
  name: 'BaseLevelTableModule',
  components: {
    LazyLoadingTable,
    SearchFilterBar
  },
  props: {
    name: String,
    headers: Array,
    index: String,
    formComponent: String,
    loadingText: String,
    scrollable: Boolean,
    path: String,
    initialFilter: {
      type: Object,
      default: function() {
        return {};
      }
    },
    searchParameter: { type: String, default: 'search' }
  },
  data() {
    return {
      searchFilter: this.initialFilter,
      internalHeaders: this.headers,
      loading: true,
    };
  },
  computed: {
    //...mapState('search', ['searchExpression']),
    filterValues() {
      return {
        [this.searchParameter]: this.searchExpression,
        indexName: this.index,
        ...this.searchFilter
      };
    },
    cssClass() {
      return this.scrollable ? 'w-table-module__table tableScrollable' : 'w-table-module__table';
    }
  },
  methods: {
    openForm(item) {
      let id = item.id;
      this.$router.push(this.formComponent + '/' + id);
    },
    openNew() {
      this.$router.push(this.formComponent);
    }
  }
};
</script>

<style lang="scss">
.w-table-module {
  display: flex;
  flex-direction: column;

  &__search-bar {
    flex: none;
    padding: 16px 0;
  }

  &__table {
    background-color: var(--v-bg-base) !important;
    & th {
      background-color: var(--v-bg-base) !important;
    }
  }
}

.tableScrollable {
  height: 69vh;
}

.v-data-table > .v-data-table__wrapper > table > thead > tr > th {
  white-space: nowrap;
  padding: 0 8px;
}

</style>